<template>
  <div class="apply-return">
    <div class="warn">
      <img src="../../assets/newImg/warn.png" alt="" />
      <div>退货商品请保持包装完好，且不影响二次销售</div>
    </div>
    <div
      class="goodsStyle acea-row row-between"
      v-for="cart in orderInfo.cartInfo"
      :key="cart.id"
    >
      <div class="pictrue">
        <img :src="cart.productInfo.image" class="image" />
      </div>
      <div class="text">
        <div class="name line2">{{ cart.productInfo.store_name }}</div>
        <div class="money">
          <div class="money-time">
            ￥{{
              cart.productInfo.attrInfo
                ? cart.productInfo.attrInfo.price
                : cart.productInfo.price
            }}
          </div>
          <div class="acea-row row-between">
            <div class="left-order">
              {{ cart.productInfo.attrInfo.suk }}
            </div>
            <div class="right-order">x{{ cart.cart_num }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="list-reson">
      <div class="li-reson">
        <div class="title-reson">退款原因</div>
        <textarea placeholder="请输入退款原因" v-model="reason"></textarea>
      </div>
      <div class="li-reson" style="border:none">
        <div class="title-reson">退款说明</div>
        <textarea
          placeholder="请输入退款说明"
          v-model="refund_reason_wap_explain"
        ></textarea>
      </div>
    </div>
    <div class="list">
      <!-- <div class="item acea-row row-between-wrapper">
        <div>退货件数</div>
        <div class="num">{{ orderInfo.total_num }}</div>
      </div> -->
      <!-- <div class="item acea-row row-between-wrapper">
        <div>退款原因</div>
        <div class="num acea-row row-left">
          <select v-model="reason">
            <option value="">选择退款原因</option>
            <option
              v-for="(text, index) in reasonList"
              :value="text"
              :key="index"
            >
              {{ text }}
            </option>
          </select>
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
      <div class="item textarea acea-row row-between">
        <div>备注说明</div>
        <textarea
          placeholder="填写备注信息，100字以内"
          class="num"
          v-model="refund_reason_wap_explain"
        ></textarea>
      </div> -->
      <div class="item acea-row row-between">
        <div class="title acea-row row-between-wrapper">
          <div class="up-img-txt">上传照片</div>
          <!-- <div class="tip">( 最多可上传3张 )</div> -->
        </div>
        <div class="upload acea-row row-middle">
          <div
            class="pictrue"
            v-for="(img, index) in refund_reason_wap_img"
            :key="img"
          >
            <img :src="img" />
            <div
              class="iconfont icon-guanbi1 font-color-red"
              @click="refund_reason_wap_img.splice(index, 1)"
            ></div>
          </div>
          <VueCoreImageUpload
            class="btn btn-primary"
            :crop="false"
            compress="80"
            @imageuploaded="imageuploaded"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
          >
            <div class="pictrue acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
              <div>上传凭证</div>
            </div>
          </VueCoreImageUpload>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>退款金额</div>
        <div class="num mon-num">￥{{ orderInfo.pay_price }}</div>
      </div>
    </div>
    <div class="returnBnt bg-color-red" @click="submit">提交</div>
  </div>
</template>

<script>
import { orderDetail, getRefundReason, postOrderRefund } from "@api/order";
import { trim, VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";

export default {
  name: "goodsReturn",
  components: {
    VueCoreImageUpload
  },
  data() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      id: this.$route.params.id || 0,
      orderInfo: {},
      reasonList: [],
      reason: "",
      refund_reason_wap_explain: "",
      refund_reason_wap_img: []
    };
  },
  methods: {
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      this.refund_reason_wap_img.push(res.data.url);
    },
    getOrderDetail() {
      orderDetail(this.id)
        .then(res => {
          this.orderInfo = res.data;
        })
        .catch(err => {
          this.$dialog.error(err.msg || "获取订单失败");
        });
    },
    getRefundReason() {
      getRefundReason().then(res => {
        this.reasonList = res.data;
      });
    },
    submit() {
      const refund_reason_wap_explain = trim(this.refund_reason_wap_explain),
        text = this.reason;
      if (!text) return this.$dialog.toast({ mes: "请选择退款原因" });
      postOrderRefund({
        text,
        uni: this.orderInfo.order_id,
        refund_reason_wap_img: this.refund_reason_wap_img.join(","),
        refund_reason_wap_explain
      })
        .then(res => {
          this.$dialog.success(res.msg);
          this.$router.go(-1);
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    }
  },
  mounted() {
    this.getOrderDetail();
    this.getRefundReason();
  }
};
</script>
<style scoped>
.line2 {
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.left-order {
  height: 22px;
  background: #f8f8f8;
  border-radius: 2px;
  padding: 0 13px;
  background: #f8f8f8;
  color: #999999;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.money-time {
  text-align: left;
  font-size: 15px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
  padding: 7px 0;
}
.goodsStyle .pictrue {
  width: 86px;
  height: 86px;
}
.goodsStyle .text {
  width: 4.8rem;
}
.goodsStyle .text .name {
  font-weight: 600;
}
.goodsStyle {
  margin: 0 10px 17px 10px;
  border-radius: 10px;
}
.warn {
  height: 51px;
  display: flex;
  align-items: center;
}
.warn img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 0 10px;
}
.warn div {
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #333333;
}
.apply-return .list .item .mon-num {
  color: #d01112;
}
.up-img-txt {
  font-size: 14px;
  color: #999999;
}
.list-reson {
  background: #fff;
}
.list-reson .li-reson {
  margin-left: 11px;
  height: 76px;
  border-bottom: 1px solid #f8f8f8;
}
.list-reson .li-reson .title-reson {
  height: 43px;
  display: flex;
  align-items: center;
}
.list-reson .li-reson .title-reson textarea {
  margin-left: 11px;
  width: 80%;
}
.list-reson .li-reson .title-reson textarea:placeholder {
  color: #999999;
  font-size: 13px;
}
</style>
